/*
 * @Author: betwaym 848032671@qq.com
 * @Date: 2024-01-26 11:22:55
 * @LastEditors: Betway
 * @LastEditTime: 2026-09-21 15:02:25
 * @FilePath: \mrc-ess-base-frontend\src\views\login\mixins\auth.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import ls from "@/utils/Ls"

export default {
  data() {
    return {
      client_code: "",
      auth_loading: false,
    }
  },
  created() {
    this.client_code = ls.get("base-client-code") || ""
    try {
      if (Object.keys(this.$route.query).length <= 0 && keycloakConfig && keycloakConfig.keycloak_realm && keycloakConfig.keycloak_url && keycloakConfig.keycloak_client_id) {
        this.toAuth(true, keycloakConfig)
      }
    } catch (error) {
      //没有配置
    }
  },
  mounted() {
    if (Number(this.$route.query.ess_state) === 1)
      this.$sso_auth
        .login(() => {
          this.auth_loading = true
        })
        .then((keycloak) => {
          if (!keycloak) {
            this.auth_loading = false // 登录失败
          } else {
            this.$router.push({
              path: "/dashboard",
            })
          }
        })
        .catch((error) => {
          console.log(error)
          this.auth_loading = false // 登录失败
        })
    else {
      this.$sso_auth.logout()
    }
  },
  methods: {
    toAuth(skip = false, config = null) {
      const isSubmit = skip || this.$refs.login_form.validate()
      if (!isSubmit) return
      this.auth_loading = true
      this.$sso_auth.getClient(this.client_code, this.remember, config).then((e) => {
        if (!e) this.auth_loading = false
        else {
          this.$sso_auth
            .login(() => {
              this.auth_loading = true
            })
            .then((res) => {
              if (res)
                this.$router.push({
                  path: "/dashboard",
                })
              else {
                this.auth_loading = false
                this.$sso_auth.logout()
              }
            })
        }
      })
    },
  },
}
